import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

import { useAccountsImport } from 'modules/finance/hooks/accounting/useAccountsImport'

interface ResultProps {
  summary: ReturnType<typeof useAccountsImport>['parseSummary']
  errors:
    | ReturnType<typeof useAccountsImport>['validateParseErrors']
    | ReturnType<typeof useAccountsImport>['validateSubmitErrors']
}

const Result = ({ summary, errors }: ResultProps) => {
  if (!summary && !errors) return null

  const description = (() => {
    if (errors) {
      return typeof errors === 'string'
        ? errors
        : i18n.t('finance.accounting_accounts.import_accounts_modal.errors.file_accounts_errors')
    }

    if (summary) {
      return i18n.t(
        'finance.accounting_accounts.import_accounts_modal.summary.x_lines_to_be_persist',
        {
          count: summary.received,
        }
      )
    }

    return ''
  })()

  const actions = (() => {
    if (Array.isArray(errors)) return errors

    if (summary) {
      return [
        i18n.t('finance.accounting_accounts.import_accounts_modal.summary.x_accounts_to_be_added', {
          count: summary.added,
        }),
        i18n.t(
          'finance.accounting_accounts.import_accounts_modal.summary.x_accounts_to_be_updated',
          { count: summary.updated }
        ),
        i18n.t(
          'finance.accounting_accounts.import_accounts_modal.summary.x_accounts_to_be_disabled',
          { count: summary.disabled }
        ),
      ]
    }

    return []
  })()

  return (
    <Callout
      title={
        errors
          ? i18n.t('finance.accounting_accounts.import_accounts_modal.errors.title')
          : i18n.t('finance.accounting_accounts.import_accounts_modal.summary.title')
      }
      description={description}
      type={errors ? 'warning' : 'positive'}
      action={
        <ul>
          {actions.map((message, i) => (
            <li key={i}>{message}</li>
          ))}
        </ul>
      }
    />
  )
}

export default Result
